import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-screen" }
const _hoisted_2 = { class: "candidate mt-20 sm:flex flex-grow" }
const _hoisted_3 = { class: "candidate__content w-full bg-background-light" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "candidate__header sm:flex justify-between items-center py-5 sm:px-12 px-5 border border-neutral-light bg-white" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "uppercase font-bold text-xl text-primary-base sm:text-left text-center" }, " Comparação com pessoas eleitas em 2018 ")
  ])
], -1)
const _hoisted_5 = { class: "candidate__graphs py-10 sm:px-12 px-5 grid sm:grid-cols-2 grid-cols-1 gap-10" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Idade: ")
const _hoisted_7 = { class: "font-light ml-1" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Gênero: ")
const _hoisted_9 = { class: "font-light ml-1" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Cor/Raça: ")
const _hoisted_11 = { class: "font-light ml-1" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Escolaridade: ")
const _hoisted_13 = { class: "font-light ml-1" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Trajetória política e patrimonial ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  class: "ml-2 w-6 h-6",
  fill: "none",
  stroke: "#FFFFFF",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-left text-sm break-words font-light" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, " Esta visualização apresenta o patrimônio declarado da pessoa destacada em comparação com a mediana de candidaturas eleitas em cada ano. Assim como os mandatos eletivos exercidos e o histórico de filiações. "),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Nota"),
    /*#__PURE__*/_createTextVNode(": Mediana é um tipo de média onde a presença de poucos valores muito baixos ou muito altos não a afetam. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Alerta"),
    /*#__PURE__*/_createTextVNode(": A forma de publicação de filiações partidárias pelo TSE mudou em 2021. Anteriormente, os dados abrangiam todas as pessoas filiadas e apresentavam o histórico de movimentações completo. Agora, são publicadas apenas as filiações em situação regular poucos meses antes das eleições. A última versão que possuímos da base histórica é do final de 2020. Portanto, a partir de 2021 as filiações partidárias só podem ser observadas pontualmente em anos eleitorais. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_AgeChart = _resolveComponent("AgeChart")!
  const _component_CardInfo = _resolveComponent("CardInfo")!
  const _component_GenderChart = _resolveComponent("GenderChart")!
  const _component_EthnicityChart = _resolveComponent("EthnicityChart")!
  const _component_EducationChart = _resolveComponent("EducationChart")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_PatrimonyChart = _resolveComponent("PatrimonyChart")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Sidebar, {
        name: _ctx.store.Candidates.currentCandidateSelected.name,
        party: _ctx.store.Candidates.currentCandidateSelected.party_abbreviation,
        number: _ctx.store.Candidates.currentCandidateSelected.number,
        role: _ctx.store.Candidates.currentCandidateSelected.post,
        age: _ctx.store.Candidates.currentCandidateSelected.age,
        education: _ctx.store.Candidates.currentCandidateSelected.education,
        gender: _ctx.store.Candidates.currentCandidateSelected.gender,
        ethnicity: _ctx.store.Candidates.currentCandidateSelected.ethnicity,
        timeline: _ctx.store.Candidates.currentCandidateSelected.election_history,
        image: _ctx.store.Candidates.currentCandidateSelected.image,
        status: _ctx.store.Candidates.currentCandidateSelected.status
      }, null, 8, ["name", "party", "number", "role", "age", "education", "gender", "ethnicity", "timeline", "image", "status"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.store.Role.currentRole !== 'presidente')
            ? (_openBlock(), _createBlock(_component_CardInfo, { key: 0 }, {
                title: _withCtx(() => [
                  _hoisted_6,
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.store.Candidates.currentCandidateSelected.age), 1)
                ]),
                content: _withCtx(() => [
                  _createVNode(_component_AgeChart)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.store.Role.currentRole !== 'presidente')
            ? (_openBlock(), _createBlock(_component_CardInfo, { key: 1 }, {
                title: _withCtx(() => [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.store.Candidates.currentCandidateSelected.gender), 1)
                ]),
                content: _withCtx(() => [
                  _createVNode(_component_GenderChart)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.store.Role.currentRole !== 'presidente')
            ? (_openBlock(), _createBlock(_component_CardInfo, { key: 2 }, {
                title: _withCtx(() => [
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.store.Candidates.currentCandidateSelected.ethnicity), 1)
                ]),
                content: _withCtx(() => [
                  _createVNode(_component_EthnicityChart)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.store.Role.currentRole !== 'presidente')
            ? (_openBlock(), _createBlock(_component_CardInfo, { key: 3 }, {
                title: _withCtx(() => [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.store.Candidates.currentCandidateSelected.education), 1)
                ]),
                content: _withCtx(() => [
                  _createVNode(_component_EducationChart)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_CardInfo, { class: "sm:col-span-2" }, {
            title: _withCtx(() => [
              _hoisted_14,
              _createVNode(_component_Tooltip, {
                arrow: "",
                placement: "bottom",
                class: "w-auto"
              }, {
                content: _withCtx(() => [
                  _hoisted_16
                ]),
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ]),
            content: _withCtx(() => [
              _createVNode(_component_PatrimonyChart)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}